export { A, P, R as RichText, T as Text } from '../../dist/RichText-1658459e.esm.js';
import 'react';
import 'styled-components';
import '../../dist/index-c76be973.esm.js';
import '../../dist/objectWithoutProperties-7e1dfdab.esm.js';
import '@lendi-ui/commons/utils';
import '@lendi-ui/commons/typography';
import 'react/jsx-runtime';
